import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
export abstract class AbstractService<T> {

  constructor(protected http: HttpClient, protected urlServicio: string) {
  }

  findAll(relations?: string): Observable<T[]> {
    let httpParams = new HttpParams();
    if (relations) {
      httpParams = httpParams.set("relations", relations);
    }
    return this.http.get<T[]>(this.urlServicio, { params: httpParams });
  }

  findAllConfigurables(relations?: string): Observable<T[]> {
    let httpParams = new HttpParams();
    if (relations) {
      httpParams = httpParams.set("relations", relations);
    }
    return this.http.get<T[]>(this.urlServicio + "/configurables", { params: httpParams });
  }

  findById(id: string, relations?: string): Observable<T> {
    let httpParams = new HttpParams();
    if (relations) {
      httpParams = httpParams.set("relations", relations);
    }
    return this.http.get<T>(this.urlServicio + "/" + id, { params: httpParams });
  }

  save(dto: T): Observable<T> {
    return this.http.post<T>(this.urlServicio, dto);
  }

  update(id: number, dto: T): Observable<T> {
    return this.http.put<T>(this.urlServicio + "/" + id, dto);
  }

  updatePassword(id: number, password: string): Observable<T> {
    return this.http.put<T>(this.urlServicio + "/" + id + "/clave", password);
  }

  patch(id: number, dto: T): Observable<T> {
    return this.http.patch<T>(this.urlServicio + "/" + id, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlServicio + "/" + id);
  }

}
